const key = "Ipi/Uj23mPJa8RGvPdxtrA01ODJ6u8VlkRpJy9H3G5Q=";

async function importKey(rawKey) {
    const key = await window.crypto.subtle.importKey(
        "raw",
        rawKey,
        "AES-CBC",
        true,
        ["encrypt", "decrypt"]
    );
    return key;
}

async function decrypt(encrypted, key, iv) {
    const decrypted = await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv,
        },
        key,
        encrypted
    );

    const plainText = new TextDecoder().decode(decrypted);
    return plainText;
}

function base64decode(data){
    return new Uint8Array([...atob(data)].map(s => s.charCodeAt(0)));
}

function str2Uint8Array(arr) {
    return Uint8Array.from(Array.prototype.map.call(arr, (x) => { 
    return x.charCodeAt(0); 
  }));
}

export async function decodetoken(token) {
    var json = JSON.parse(atob(token.replace(/-/g, "+").replace(/_/g, "/")));
    var encrypted = str2Uint8Array(json[0]);
    var iv = str2Uint8Array(json[1]);
    const importkey = await importKey(base64decode(key));
    return await decrypt(encrypted, importkey, iv);
}

